var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"dropdown-close-button",on:{"click":function($event){return _vm.$closeDropdown()}}},[_vm._v("\n  Close dropdown\n")])}
var staticRenderFns = []

export { render, staticRenderFns }